import { render } from "./Agenti.vue?vue&type=template&id=ab930b38&scoped=true"
import script from "./Agenti.vue?vue&type=script&lang=js"
export * from "./Agenti.vue?vue&type=script&lang=js"

import "./Agenti.vue?vue&type=style&index=0&id=ab930b38&scoped=true&lang=css"

import exportComponent from "C:\\Users\\germa\\dev\\dcpower.client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab930b38"]])

export default __exports__